import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BrowserIcon(_ref) {
  var browser = _ref.browser,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size;
  switch (browser) {
    case 'chrome':
      return /*#__PURE__*/_jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M7.97941 0.0014314C7.97941 0.0014314 12.6962 -0.210445 15.196 4.52134C13.8754 4.52134 7.57841 4.52134 7.57841 4.52134C7.57841 4.52134 6.13979 4.47409 4.91342 6.21647C4.55967 6.94623 4.18242 7.69961 4.60692 9.18262C3.99379 8.14699 1.35229 3.55621 1.35229 3.55621C1.35229 3.55621 3.21554 0.189683 7.97941 0.0014314Z",
          fill: "#E16B5A"
        }), /*#__PURE__*/_jsx("path", {
          d: "M7.97913 0.00143372C7.89775 0.00468375 7.81925 0.0110588 7.7395 0.0160588C9.013 0.108809 12.4536 0.718189 14.4629 4.52134C14.7731 4.52134 15.0259 4.52134 15.1955 4.52134C12.6957 -0.210568 7.97913 0.00143372 7.97913 0.00143372Z",
          fill: "#CC6152"
        }), /*#__PURE__*/_jsx("path", {
          d: "M14.9504 12.0154C14.9504 12.0154 12.7754 16.1983 7.42017 15.9925C8.08079 14.8511 11.2299 9.40798 11.2299 9.40798C11.2299 9.40798 11.9902 8.18785 11.0924 6.25659C10.636 5.58583 9.25354 4.88283 7.75454 4.50808C8.96004 4.49608 15.1809 4.50883 15.1809 4.50883C15.1809 4.50883 17.1694 7.80322 14.9504 12.0154Z",
          fill: "#FFD464"
        }), /*#__PURE__*/_jsx("path", {
          d: "M15.1807 4.50874C15.1807 4.50874 12.0075 4.50224 9.75454 4.50299C11.9159 4.50349 14.5049 4.50874 14.5049 4.50874C14.5049 4.50874 16.4935 7.80301 14.2745 12.0152C14.2745 12.0152 12.2815 15.8407 7.41992 15.9923C12.7752 16.1981 14.9503 12.0152 14.9503 12.0152C17.1693 7.80301 15.1807 4.50874 15.1807 4.50874Z",
          fill: "#F2C95F"
        }), /*#__PURE__*/_jsx("path", {
          d: "M1.04165 12.0474C1.04165 12.0474 -1.49973 8.07536 1.35665 3.54883C2.01677 4.69071 5.16414 10.1349 5.16414 10.1349C5.16414 10.1349 5.84214 11.4021 7.96676 11.5916C8.77664 11.5326 9.61914 11.4825 10.6938 10.3744C10.1013 11.4223 7.43839 16.0003 7.43839 16.0003C7.43839 16.0003 3.58614 16.072 1.04165 12.0474Z",
          fill: "#74B340"
        }), /*#__PURE__*/_jsx("ellipse", {
          cx: "7.95996",
          cy: "8.06448",
          rx: "3.625",
          ry: "3.62502",
          fill: "white"
        }), /*#__PURE__*/_jsx("ellipse", {
          cx: "7.95874",
          cy: "8.06447",
          rx: "2.875",
          ry: "2.87502",
          fill: "#2995CC"
        }), /*#__PURE__*/_jsx("path", {
          d: "M7.95943 5.19043C7.90218 5.19043 7.84556 5.19255 7.78931 5.1958C9.29781 5.28393 10.4941 6.53481 10.4941 8.06532C10.4941 9.59608 9.29781 10.8471 7.78931 10.9352C7.84568 10.9383 7.90231 10.9406 7.95943 10.9406C9.54705 10.9406 10.8344 9.65321 10.8344 8.06532C10.8344 6.47769 9.54705 5.19043 7.95943 5.19043Z",
          fill: "#268CBF"
        })]
      });
    case 'firefox':
      return /*#__PURE__*/_jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M14.9299 5.3678C14.5928 4.5572 13.9098 3.68145 13.3738 3.40509C13.7558 4.14443 14.0207 4.93831 14.1589 5.75859L14.1607 5.77178C13.284 3.58549 11.7974 2.70447 10.5829 0.78487C10.5213 0.688054 10.4597 0.590378 10.3998 0.488267C10.3655 0.429322 10.3382 0.376506 10.3144 0.328098C10.2642 0.230395 10.2255 0.127397 10.1991 0.0209047C10.1991 0.0103415 10.1912 0.00241234 10.1815 0.000665241C10.1771 -0.000221747 10.1718 -0.000221747 10.1665 0.000665241C10.1657 0.000665241 10.1639 0.00241234 10.163 0.00329932C10.1621 0.00329932 10.1595 0.00596029 10.1577 0.00596029L10.1604 0.000692119C8.21262 1.14133 7.55163 3.25282 7.49093 4.30901C6.71288 4.36268 5.96916 4.64875 5.35657 5.13194C5.29231 5.07738 5.22629 5.02722 5.15676 4.98054C4.97987 4.36182 4.9728 3.70784 5.13477 3.08472C4.41921 3.43148 3.78373 3.92263 3.26799 4.52729H3.26446C2.9573 4.13736 2.9784 2.85324 2.99603 2.58478C2.90537 2.62174 2.81826 2.66751 2.73727 2.72208C2.46618 2.91571 2.21268 3.1331 1.97946 3.37162C1.71366 3.64094 1.47162 3.93139 1.25423 4.24122V4.24211V4.24033C0.75609 4.9471 0.402262 5.74539 0.213898 6.59034L0.203335 6.64138C0.188364 6.71003 0.136435 7.05155 0.126759 7.12546C0.126759 7.13164 0.125872 7.13691 0.124985 7.14218C0.0580843 7.49512 0.0158314 7.85247 0 8.21156V8.25118C0.00352107 12.534 3.47922 16.0035 7.762 15.9991C11.5343 15.9956 14.7565 13.2795 15.3973 9.56172C15.4105 9.46141 15.421 9.36282 15.4325 9.2616C15.5927 7.9431 15.4193 6.60351 14.9299 5.3678ZM5.99206 11.4373C6.03351 11.4777 6.07296 11.5202 6.11547 11.5587L6.12152 11.5668C6.07803 11.5262 6.03453 11.4838 5.99206 11.4373ZM14.1616 5.80041V5.76649L14.17 5.80468L14.1616 5.80041Z",
          fill: "url(#firefox-paint0_linear_3554_19925)"
        }), /*#__PURE__*/_jsx("path", {
          d: "M14.93 5.36897C14.5929 4.55837 13.9099 3.68261 13.3739 3.40625C13.7559 4.14559 14.0208 4.93948 14.159 5.75975V5.76679L14.1607 5.77472C14.7583 7.48486 14.6721 9.36044 13.9196 11.009C13.0306 12.9162 10.8795 14.8711 7.51206 14.776C3.87356 14.673 0.668923 11.9727 0.0695345 8.43628C-0.0396188 7.87825 0.0695345 7.59574 0.124098 7.14246C0.0501551 7.49451 0.00792913 7.85275 0 8.2127V8.25232C0.00352107 12.5351 3.47922 16.0047 7.762 16.0003C11.5343 15.9967 14.7565 13.2806 15.3973 9.56286C15.4105 9.46255 15.421 9.36396 15.4325 9.26273C15.5928 7.94427 15.4193 6.60467 14.93 5.36897Z",
          fill: "url(#firefox-paint1_radial_3554_19925)"
        }), /*#__PURE__*/_jsx("path", {
          d: "M14.93 5.36897C14.5929 4.55837 13.9099 3.68261 13.3739 3.40625C13.7559 4.14559 14.0208 4.93948 14.159 5.75975V5.76679L14.1607 5.77472C14.7583 7.48486 14.6721 9.36044 13.9196 11.009C13.0306 12.9162 10.8795 14.8711 7.51206 14.776C3.87356 14.673 0.668923 11.9727 0.0695345 8.43628C-0.0396188 7.87825 0.0695345 7.59574 0.124098 7.14246C0.0501551 7.49451 0.00792913 7.85275 0 8.2127V8.25232C0.00352107 12.5351 3.47922 16.0047 7.762 16.0003C11.5343 15.9967 14.7565 13.2806 15.3973 9.56286C15.4105 9.46255 15.421 9.36396 15.4325 9.26273C15.5928 7.94427 15.4193 6.60467 14.93 5.36897Z",
          fill: "url(#firefox-paint2_radial_3554_19925)"
        }), /*#__PURE__*/_jsx("path", {
          d: "M11.1614 6.28C11.1781 6.29145 11.194 6.30378 11.2098 6.31521C11.0153 5.9702 10.7724 5.65335 10.4898 5.3761C8.07912 2.96541 9.85788 0.149811 10.158 0.0063343L10.1607 0.00195312C8.2129 1.14259 7.5519 3.25408 7.49121 4.31027C7.58184 4.30411 7.67165 4.29618 7.76403 4.29618C9.17047 4.29879 10.4678 5.05663 11.1614 6.28Z",
          fill: "url(#firefox-paint3_radial_3554_19925)"
        }), /*#__PURE__*/_jsx("path", {
          d: "M7.7684 6.76121C7.7552 6.95396 7.07397 7.61936 6.83545 7.61936C4.6307 7.61936 4.27246 8.95369 4.27246 8.95369C4.37016 10.0767 5.15262 11.0018 6.09877 11.4911C6.14188 11.5131 6.18591 11.5334 6.22991 11.5536C6.3056 11.5871 6.38131 11.6188 6.45789 11.6469C6.78266 11.7622 7.12241 11.8274 7.46653 11.8414C11.3312 12.0227 12.0802 7.21979 9.29106 5.82563C9.94942 5.74024 10.6157 5.90221 11.1605 6.27977C10.4678 5.05637 9.17049 4.29856 7.76316 4.2959C7.67075 4.2959 7.58098 4.30383 7.49032 4.30998C6.71227 4.36366 5.96854 4.64973 5.35598 5.13292C5.47393 5.23323 5.60767 5.36703 5.88847 5.64339C6.41561 6.16182 7.76574 6.69872 7.7684 6.76121Z",
          fill: "url(#firefox-paint4_radial_3554_19925)"
        }), /*#__PURE__*/_jsx("path", {
          d: "M7.7684 6.76121C7.7552 6.95396 7.07397 7.61936 6.83545 7.61936C4.6307 7.61936 4.27246 8.95369 4.27246 8.95369C4.37016 10.0767 5.15262 11.0018 6.09877 11.4911C6.14188 11.5131 6.18591 11.5334 6.22991 11.5536C6.3056 11.5871 6.38131 11.6188 6.45789 11.6469C6.78266 11.7622 7.12241 11.8274 7.46653 11.8414C11.3312 12.0227 12.0802 7.21979 9.29106 5.82563C9.94942 5.74024 10.6157 5.90221 11.1605 6.27977C10.4678 5.05637 9.17049 4.29856 7.76316 4.2959C7.67075 4.2959 7.58098 4.30383 7.49032 4.30998C6.71227 4.36366 5.96854 4.64973 5.35598 5.13292C5.47393 5.23323 5.60767 5.36703 5.88847 5.64339C6.41561 6.16182 7.76574 6.69872 7.7684 6.76121Z",
          fill: "url(#firefox-paint5_radial_3554_19925)"
        }), /*#__PURE__*/_jsx("path", {
          d: "M4.99521 4.87431C5.05767 4.9139 5.10963 4.94911 5.15537 4.9808C4.97849 4.36204 4.97142 3.70808 5.13339 3.08496C4.41783 3.43175 3.78234 3.92287 3.2666 4.52753C3.30531 4.52667 4.43017 4.5064 4.99521 4.87431Z",
          fill: "url(#firefox-paint6_radial_3554_19925)"
        }), /*#__PURE__*/_jsx("path", {
          d: "M0.0706792 8.43647C0.669181 11.9729 3.87379 14.6723 7.51229 14.7762C10.8797 14.8712 13.0308 12.9164 13.9198 11.0091C14.6723 9.36063 14.7586 7.48592 14.1609 5.77492V5.76788C14.1609 5.76169 14.1601 5.75909 14.1609 5.76083L14.1627 5.77403C14.4382 7.5704 13.5246 9.31045 12.0961 10.4872L12.0917 10.4969C9.30868 12.7633 6.64536 11.8647 6.10671 11.4976C6.06887 11.48 6.03191 11.4607 5.99406 11.4413C4.37192 10.6659 3.70128 9.18724 3.84473 7.91982C3.05789 7.93127 2.3379 7.47887 2.00786 6.76418C2.87394 6.23346 3.95297 6.19032 4.85867 6.64976C5.77667 7.06694 6.8223 7.10744 7.77019 6.76418C7.76753 6.70082 6.4174 6.16393 5.89109 5.64552C5.61032 5.3683 5.47652 5.23536 5.35858 5.13505C5.29431 5.08049 5.2283 5.03033 5.15876 4.98364C5.11302 4.95195 5.06106 4.91852 4.9986 4.87715C4.43264 4.50924 3.30784 4.52948 3.27088 4.53039H3.26736C2.96016 4.14047 2.98129 2.85635 2.99889 2.58789C2.90826 2.62485 2.82112 2.67062 2.74014 2.72519C2.46907 2.91882 2.21558 3.13621 1.98235 3.37473C1.71567 3.64316 1.47274 3.93361 1.25446 4.24255V4.24341V4.24167C0.756321 4.94843 0.402493 5.74672 0.214129 6.59167C0.210608 6.60753 -0.0648687 7.81158 0.0706792 8.43647Z",
          fill: "url(#firefox-paint7_radial_3554_19925)"
        }), /*#__PURE__*/_jsx("path", {
          d: "M10.4898 5.37568C10.7732 5.65382 11.0153 5.97069 11.2098 6.3157C11.252 6.34828 11.2925 6.37997 11.3259 6.41074C13.0845 8.03111 12.163 10.3221 12.0943 10.4858C13.5228 9.30907 14.4355 7.56904 14.1609 5.77265C13.2834 3.5855 11.7968 2.70448 10.5822 0.784877C10.5206 0.688061 10.459 0.590357 10.3991 0.488273C10.3648 0.429302 10.3375 0.376486 10.3138 0.328078C10.2636 0.230375 10.2248 0.127404 10.1984 0.0209114C10.1984 0.0103213 10.1905 0.00241906 10.1808 0.000645082C10.1765 -0.000215027 10.1712 -0.000215027 10.1659 0.000645082C10.165 0.000645082 10.1632 0.00239218 10.1623 0.00330605C10.1615 0.00330605 10.1588 0.00594013 10.1571 0.00594013C9.85784 0.14939 8.07908 2.96498 10.4898 5.37568Z",
          fill: "url(#firefox-paint8_radial_3554_19925)"
        }), /*#__PURE__*/_jsx("path", {
          d: "M11.3252 6.41039C11.2918 6.37962 11.2513 6.34704 11.209 6.31535C11.1932 6.3039 11.1773 6.29159 11.1606 6.28014C10.6149 5.90255 9.94865 5.74061 9.29117 5.82598C12.0803 7.22102 11.3322 12.0231 7.46664 11.8418C7.12249 11.8277 6.78277 11.7617 6.458 11.6473C6.38231 11.6191 6.30659 11.5874 6.23002 11.554C6.18602 11.5337 6.14202 11.5144 6.09888 11.4915L6.10415 11.495C6.64279 11.8629 9.30526 12.7615 12.0891 10.4943L12.0935 10.4846C12.1631 10.3218 13.0837 8.02987 11.3252 6.41039Z",
          fill: "url(#firefox-paint9_radial_3554_19925)"
        }), /*#__PURE__*/_jsx("path", {
          d: "M4.27225 8.95344C4.27225 8.95344 4.63048 7.61911 6.83524 7.61911C7.07376 7.61911 7.75585 6.95371 7.76819 6.76096C6.82027 7.1042 5.77464 7.06375 4.85666 6.64654C3.951 6.18708 2.87194 6.23022 2.00586 6.76096C2.3359 7.47563 3.05586 7.92802 3.84273 7.91657C3.69925 9.18489 4.36906 10.6627 5.99206 11.4381C6.02813 11.4557 6.06246 11.4742 6.09944 11.4909C5.15241 11.0015 4.36992 10.0765 4.27225 8.95344Z",
          fill: "url(#firefox-paint10_radial_3554_19925)"
        }), /*#__PURE__*/_jsx("path", {
          d: "M14.93 5.3678C14.5929 4.5572 13.9099 3.68145 13.3738 3.40509C13.7558 4.14443 14.0207 4.93831 14.1589 5.75859L14.1607 5.77178C13.2841 3.58549 11.7975 2.70447 10.5829 0.78487C10.5213 0.688054 10.4597 0.590378 10.3998 0.488267C10.3655 0.429322 10.3382 0.376506 10.3144 0.328098C10.2643 0.230395 10.2255 0.127397 10.1991 0.0209047C10.1991 0.0103415 10.1912 0.00241234 10.1815 0.000665241C10.1771 -0.000221747 10.1719 -0.000221747 10.1666 0.000665241L10.1631 0.00329932L10.1578 0.00596029L10.1604 0.000692119C8.21265 1.14133 7.55165 3.25282 7.49096 4.30901C7.5816 4.30285 7.6714 4.29492 7.76378 4.29492C9.17113 4.29758 10.4676 5.05539 11.162 6.27879C10.6163 5.9012 9.95007 5.73926 9.29259 5.82465C12.0818 7.21967 11.3336 12.0218 7.46806 11.8404C7.12391 11.8264 6.78419 11.7604 6.45942 11.646C6.38373 11.6178 6.30802 11.5861 6.23144 11.5526C6.18744 11.5324 6.14344 11.513 6.1003 11.4902L6.10557 11.4937C6.06772 11.4761 6.03077 11.4567 5.99292 11.4374C6.02902 11.4549 6.06334 11.4734 6.1003 11.4902C5.15326 11.0008 4.37167 10.0758 4.27399 8.95271C4.27399 8.95271 4.63223 7.61838 6.83698 7.61838C7.0755 7.61838 7.7576 6.95298 7.76993 6.76024C7.76727 6.69688 6.41714 6.15996 5.89084 5.64156C5.61006 5.36433 5.47626 5.23142 5.35832 5.13108C5.29405 5.07652 5.22804 5.02636 5.15851 4.9797C4.98162 4.36094 4.97455 3.70698 5.13652 3.08386C4.42096 3.43065 3.7855 3.92177 3.26973 4.52643H3.26621C2.95905 4.13653 2.98014 2.85241 2.99778 2.58392C2.90712 2.62091 2.82 2.66665 2.73902 2.72122C2.46792 2.91485 2.21443 3.13224 1.98121 3.37079C1.71541 3.64011 1.47339 3.93053 1.25597 4.24039C0.757837 4.94715 0.404009 5.74453 0.215646 6.58948L0.205082 6.64052C0.190111 6.70917 0.124985 7.05507 0.115308 7.12987C0.115308 7.12369 0.115308 7.13514 0.115308 7.12987C0.0545632 7.48808 0.0167184 7.84895 0 8.21156V8.25118C0.00352107 12.534 3.47922 16.0035 7.762 15.9991C11.5343 15.9956 14.7565 13.2795 15.3973 9.56172C15.4105 9.46141 15.421 9.36282 15.4325 9.2616C15.5927 7.9431 15.4193 6.60351 14.93 5.3678Z",
          fill: "url(#firefox-paint11_linear_3554_19925)"
        }), /*#__PURE__*/_jsxs("defs", {
          children: [/*#__PURE__*/_jsxs("linearGradient", {
            id: "firefox-paint0_linear_3554_19925",
            x1: "13.5168",
            y1: "2.47751",
            x2: "1.06072",
            y2: "14.4953",
            gradientUnits: "userSpaceOnUse",
            children: [/*#__PURE__*/_jsx("stop", {
              offset: "0.048",
              stopColor: "#FFF44F"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.111",
              stopColor: "#FFE847"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.225",
              stopColor: "#FFC830"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.368",
              stopColor: "#FF980E"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.401",
              stopColor: "#FF8B16"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.462",
              stopColor: "#FF672A"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.534",
              stopColor: "#FF3647"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.705",
              stopColor: "#E31587"
            })]
          }), /*#__PURE__*/_jsxs("radialGradient", {
            id: "firefox-paint1_radial_3554_19925",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(11.024 1.77671) scale(16.1663 16.1663)",
            children: [/*#__PURE__*/_jsx("stop", {
              offset: "0.129",
              stopColor: "#FFBD4F"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.186",
              stopColor: "#FFAC31"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.247",
              stopColor: "#FF9D17"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.283",
              stopColor: "#FF980E"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.403",
              stopColor: "#FF563B"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.467",
              stopColor: "#FF3750"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.71",
              stopColor: "#F5156C"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.782",
              stopColor: "#EB0878"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.86",
              stopColor: "#E50080"
            })]
          }), /*#__PURE__*/_jsxs("radialGradient", {
            id: "firefox-paint2_radial_3554_19925",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(6.12891 8.38599) scale(16.1664 16.1664)",
            children: [/*#__PURE__*/_jsx("stop", {
              offset: "0.3",
              stopColor: "#960E18"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.351",
              stopColor: "#B11927",
              stopOpacity: "0.74"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.435",
              stopColor: "#DB293D",
              stopOpacity: "0.343"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.497",
              stopColor: "#F5334B",
              stopOpacity: "0.094"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.53",
              stopColor: "#FF3750",
              stopOpacity: "0"
            })]
          }), /*#__PURE__*/_jsxs("radialGradient", {
            id: "firefox-paint3_radial_3554_19925",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(9.35047 -1.28461) scale(11.7114 11.7114)",
            children: [/*#__PURE__*/_jsx("stop", {
              offset: "0.132",
              stopColor: "#FFF44F"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.252",
              stopColor: "#FFDC3E"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.506",
              stopColor: "#FF9D12"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.526",
              stopColor: "#FF980E"
            })]
          }), /*#__PURE__*/_jsxs("radialGradient", {
            id: "firefox-paint4_radial_3554_19925",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(5.61306 11.6251) scale(7.6975 7.6975)",
            children: [/*#__PURE__*/_jsx("stop", {
              offset: "0.353",
              stopColor: "#3A8EE6"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.472",
              stopColor: "#5C79F0"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.669",
              stopColor: "#9059FF"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "1",
              stopColor: "#C139E6"
            })]
          }), /*#__PURE__*/_jsxs("radialGradient", {
            id: "firefox-paint5_radial_3554_19925",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(9.62763 4.69177) rotate(-12.4449) scale(4.06263 4.10066)",
            children: [/*#__PURE__*/_jsx("stop", {
              offset: "0.206",
              stopColor: "#9059FF",
              stopOpacity: "0"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.278",
              stopColor: "#8C4FF3",
              stopOpacity: "0.064"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.747",
              stopColor: "#7716A8",
              stopOpacity: "0.45"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.975",
              stopColor: "#6E008B",
              stopOpacity: "0.6"
            })]
          }), /*#__PURE__*/_jsxs("radialGradient", {
            id: "firefox-paint6_radial_3554_19925",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(7.19726 1.10598) scale(5.53762 5.53762)",
            children: [/*#__PURE__*/_jsx("stop", {
              stopColor: "#FFE226"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.121",
              stopColor: "#FFDB27"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.295",
              stopColor: "#FFC82A"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.502",
              stopColor: "#FFA930"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.732",
              stopColor: "#FF7E37"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.792",
              stopColor: "#FF7139"
            })]
          }), /*#__PURE__*/_jsxs("radialGradient", {
            id: "firefox-paint7_radial_3554_19925",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(9.85847 -2.39692) scale(23.6263 23.6263)",
            children: [/*#__PURE__*/_jsx("stop", {
              offset: "0.113",
              stopColor: "#FFF44F"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.456",
              stopColor: "#FF980E"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.622",
              stopColor: "#FF5634"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.716",
              stopColor: "#FF3647"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.904",
              stopColor: "#E31587"
            })]
          }), /*#__PURE__*/_jsxs("radialGradient", {
            id: "firefox-paint8_radial_3554_19925",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(1.97675 4.26608) rotate(77.4291) scale(8.35412 35.8931)",
            children: [/*#__PURE__*/_jsx("stop", {
              stopColor: "#FFF44F"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.06",
              stopColor: "#FFE847"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.168",
              stopColor: "#FFC830"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.304",
              stopColor: "#FF980E"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.356",
              stopColor: "#FF8B16"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.455",
              stopColor: "#FF672A"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.57",
              stopColor: "#FF3647"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.737",
              stopColor: "#E31587"
            })]
          }), /*#__PURE__*/_jsxs("radialGradient", {
            id: "firefox-paint9_radial_3554_19925",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(6.9381 3.16572) scale(14.7503 14.7503)",
            children: [/*#__PURE__*/_jsx("stop", {
              offset: "0.137",
              stopColor: "#FFF44F"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.48",
              stopColor: "#FF980E"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.592",
              stopColor: "#FF5634"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.655",
              stopColor: "#FF3647"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.904",
              stopColor: "#E31587"
            })]
          }), /*#__PURE__*/_jsxs("radialGradient", {
            id: "firefox-paint10_radial_3554_19925",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(10.0239 4.02925) scale(16.1442 16.1442)",
            children: [/*#__PURE__*/_jsx("stop", {
              offset: "0.094",
              stopColor: "#FFF44F"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.231",
              stopColor: "#FFE141"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.509",
              stopColor: "#FFAF1E"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.626",
              stopColor: "#FF980E"
            })]
          }), /*#__PURE__*/_jsxs("linearGradient", {
            id: "firefox-paint11_linear_3554_19925",
            x1: "13.3722",
            y1: "2.41151",
            x2: "2.76108",
            y2: "13.0224",
            gradientUnits: "userSpaceOnUse",
            children: [/*#__PURE__*/_jsx("stop", {
              offset: "0.167",
              stopColor: "#FFF44F",
              stopOpacity: "0.8"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.266",
              stopColor: "#FFF44F",
              stopOpacity: "0.634"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.489",
              stopColor: "#FFF44F",
              stopOpacity: "0.217"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "0.6",
              stopColor: "#FFF44F",
              stopOpacity: "0"
            })]
          })]
        })]
      });
    case 'safari':
      return /*#__PURE__*/_jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [/*#__PURE__*/_jsx("circle", {
          cx: "8",
          cy: "8",
          r: "8",
          fill: "url(#safari-paint0_linear_3554_19865)"
        }), /*#__PURE__*/_jsx("path", {
          d: "M13.4641 2.5L7.32129 7.32143L8.74986 8.75L13.4641 2.5Z",
          fill: "#FF0000"
        }), /*#__PURE__*/_jsx("path", {
          d: "M2.5 13.4641L7.32143 7.32129L8.75 8.74986L2.5 13.4641Z",
          fill: "white"
        }), /*#__PURE__*/_jsx("defs", {
          children: /*#__PURE__*/_jsxs("linearGradient", {
            id: "safari-paint0_linear_3554_19865",
            x1: "0",
            y1: "0",
            x2: "0",
            y2: "16",
            gradientUnits: "userSpaceOnUse",
            children: [/*#__PURE__*/_jsx("stop", {
              stopColor: "#19D7FF"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "1",
              stopColor: "#1E64F0"
            })]
          })
        })]
      });
    case 'edge':
      return /*#__PURE__*/_jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 21 21",
        version: "1.1",
        "aria-hidden": "true",
        children: [/*#__PURE__*/_jsxs("defs", {
          children: [/*#__PURE__*/_jsxs("linearGradient", {
            x1: "-7.97051215e-15%",
            y1: "50.0129955%",
            x2: "100.026435%",
            y2: "50.0129955%",
            id: "edge-linearGradient-1",
            children: [/*#__PURE__*/_jsx("stop", {
              stopColor: "#0C59A4",
              offset: "0%"
            }), /*#__PURE__*/_jsx("stop", {
              stopColor: "#114A8B",
              offset: "100%"
            })]
          }), /*#__PURE__*/_jsxs("radialGradient", {
            cx: "55.2461807%",
            cy: "50.9262508%",
            fx: "55.2461807%",
            fy: "50.9262508%",
            r: "61.9753086%",
            gradientTransform: "translate(0.552462,0.509263),scale(0.863187,1.000000),translate(-0.552462,-0.509263)",
            id: "edge-radialGradient-2",
            children: [/*#__PURE__*/_jsx("stop", {
              stopColor: "#000000",
              stopOpacity: "0",
              offset: "72%"
            }), /*#__PURE__*/_jsx("stop", {
              stopColor: "#000000",
              stopOpacity: "0.53",
              offset: "95%"
            }), /*#__PURE__*/_jsx("stop", {
              stopColor: "#000000",
              offset: "100%"
            })]
          }), /*#__PURE__*/_jsxs("linearGradient", {
            x1: "90.5872701%",
            y1: "24.7942842%",
            x2: "24.4785698%",
            y2: "83.1510351%",
            id: "edge-linearGradient-3",
            children: [/*#__PURE__*/_jsx("stop", {
              stopColor: "#1B9DE2",
              offset: "0%"
            }), /*#__PURE__*/_jsx("stop", {
              stopColor: "#1595DF",
              offset: "16%"
            }), /*#__PURE__*/_jsx("stop", {
              stopColor: "#0680D7",
              offset: "67%"
            }), /*#__PURE__*/_jsx("stop", {
              stopColor: "#0078D4",
              offset: "100%"
            })]
          }), /*#__PURE__*/_jsxs("radialGradient", {
            cx: "51.5261383%",
            cy: "20.7274079%",
            fx: "51.5261383%",
            fy: "20.7274079%",
            r: "105.641453%",
            gradientTransform: "translate(0.515261,0.207274),scale(1.000000,0.810421),rotate(-72.277194),scale(1.000000,2.464105),translate(-0.515261,-0.207274)",
            id: "edge-radialGradient-4",
            children: [/*#__PURE__*/_jsx("stop", {
              stopColor: "#000000",
              stopOpacity: "0",
              offset: "0%"
            }), /*#__PURE__*/_jsx("stop", {
              stopColor: "#000000",
              stopOpacity: "0.5",
              offset: "95%"
            }), /*#__PURE__*/_jsx("stop", {
              stopColor: "#000000",
              offset: "100%"
            })]
          }), /*#__PURE__*/_jsxs("radialGradient", {
            cx: "10.1019077%",
            cy: "27.7890034%",
            fx: "10.1019077%",
            fy: "27.7890034%",
            r: "118.830871%",
            gradientTransform: "translate(0.101019,0.277890),scale(0.665925,1.000000),rotate(92.290610),translate(-0.101019,-0.277890)",
            id: "edge-radialGradient-5",
            children: [/*#__PURE__*/_jsx("stop", {
              stopColor: "#35C1F1",
              offset: "0%"
            }), /*#__PURE__*/_jsx("stop", {
              stopColor: "#34C1ED",
              offset: "11%"
            }), /*#__PURE__*/_jsx("stop", {
              stopColor: "#2FC2DF",
              offset: "23%"
            }), /*#__PURE__*/_jsx("stop", {
              stopColor: "#2BC3D2",
              offset: "31%"
            }), /*#__PURE__*/_jsx("stop", {
              stopColor: "#36C752",
              offset: "67%"
            })]
          }), /*#__PURE__*/_jsxs("radialGradient", {
            cx: "93.7723426%",
            cy: "45.4027789%",
            fx: "93.7723426%",
            fy: "45.4027789%",
            r: "57.0950674%",
            gradientTransform: "translate(0.937723,0.454028),scale(0.665925,1.000000),rotate(73.739795),translate(-0.937723,-0.454028)",
            id: "edge-radialGradient-6",
            children: [/*#__PURE__*/_jsx("stop", {
              stopColor: "#66EB6E",
              offset: "0%"
            }), /*#__PURE__*/_jsx("stop", {
              stopColor: "#66EB6E",
              stopOpacity: "0",
              offset: "100%"
            })]
          })]
        }), /*#__PURE__*/_jsx("g", {
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd",
          children: /*#__PURE__*/_jsx("g", {
            transform: "translate(-443.000000, -129.000000)",
            fillRule: "nonzero",
            children: /*#__PURE__*/_jsxs("g", {
              transform: "translate(443.000000, 129.000000)",
              children: [/*#__PURE__*/_jsx("path", {
                d: "M18.961284,15.5694163 C18.682383,15.7152788 18.3947559,15.8438105 18.1000389,15.9542802 C17.1619401,16.3052904 16.1681914,16.4841098 15.1665759,16.4821401 C11.2999611,16.4821401 7.93178988,13.8224125 7.93178988,10.4092996 C7.94186951,9.47712998 8.45550244,8.62336764 9.27431907,8.17774319 C5.7770428,8.3248249 4.87821012,11.9691829 4.87821012,14.1043191 C4.87821012,20.1412062 10.4419844,20.7532296 11.6407004,20.7532296 C12.2870428,20.7532296 13.2618677,20.5652918 13.8469261,20.3806226 L13.9539689,20.3446693 C16.2053357,19.5663543 18.1246408,18.0447431 19.3959922,16.0302724 C19.4760978,15.9040626 19.4603707,15.7395908 19.3577986,15.630849 C19.2552265,15.5221072 19.0919526,15.4968109 18.961284,15.5694163 Z",
                fill: "url(#edge-linearGradient-1)"
              }), /*#__PURE__*/_jsx("path", {
                d: "M18.961284,15.5694163 C18.682383,15.7152788 18.3947559,15.8438105 18.1000389,15.9542802 C17.1619401,16.3052904 16.1681914,16.4841098 15.1665759,16.4821401 C11.2999611,16.4821401 7.93178988,13.8224125 7.93178988,10.4092996 C7.94186951,9.47712998 8.45550244,8.62336764 9.27431907,8.17774319 C5.7770428,8.3248249 4.87821012,11.9691829 4.87821012,14.1043191 C4.87821012,20.1412062 10.4419844,20.7532296 11.6407004,20.7532296 C12.2870428,20.7532296 13.2618677,20.5652918 13.8469261,20.3806226 L13.9539689,20.3446693 C16.2053357,19.5663543 18.1246408,18.0447431 19.3959922,16.0302724 C19.4760978,15.9040626 19.4603707,15.7395908 19.3577986,15.630849 C19.2552265,15.5221072 19.0919526,15.4968109 18.961284,15.5694163 Z",
                fill: "url(#edge-radialGradient-2)",
                opacity: "0.35"
              }), /*#__PURE__*/_jsx("path", {
                d: "M8.71949416,19.7269261 C7.99067422,19.27457 7.35905492,18.6818366 6.86136187,17.9831907 C5.71310645,16.4100039 5.31885118,14.4097592 5.78425496,12.5185146 C6.24965875,10.6272699 7.52713285,9.03841 9.27431907,8.17774319 C9.5292607,8.05762646 9.96478599,7.84027237 10.5441245,7.85089494 C11.3715414,7.8569193 12.1484007,8.25003608 12.6433074,8.91315175 C12.9732796,9.35372941 13.1552107,9.88750832 13.1629961,10.4378988 C13.1629961,10.4207393 15.1616732,3.93361868 6.62603113,3.93361868 C3.0388716,3.93361868 0.0890661479,7.33774319 0.0890661479,10.3243191 C0.0749168297,11.9041781 0.412950971,13.4673418 1.07859922,14.9001946 C3.33039153,19.7047123 8.82300399,22.0618502 13.8567315,20.3838911 C12.1335038,20.9272145 10.2587482,20.6883161 8.72684825,19.7301946 L8.71949416,19.7269261 Z",
                fill: "url(#edge-linearGradient-3)"
              }), /*#__PURE__*/_jsx("path", {
                d: "M8.71949416,19.7269261 C7.99067422,19.27457 7.35905492,18.6818366 6.86136187,17.9831907 C5.71310645,16.4100039 5.31885118,14.4097592 5.78425496,12.5185146 C6.24965875,10.6272699 7.52713285,9.03841 9.27431907,8.17774319 C9.5292607,8.05762646 9.96478599,7.84027237 10.5441245,7.85089494 C11.3715414,7.8569193 12.1484007,8.25003608 12.6433074,8.91315175 C12.9732796,9.35372941 13.1552107,9.88750832 13.1629961,10.4378988 C13.1629961,10.4207393 15.1616732,3.93361868 6.62603113,3.93361868 C3.0388716,3.93361868 0.0890661479,7.33774319 0.0890661479,10.3243191 C0.0749168297,11.9041781 0.412950971,13.4673418 1.07859922,14.9001946 C3.33039153,19.7047123 8.82300399,22.0618502 13.8567315,20.3838911 C12.1335038,20.9272145 10.2587482,20.6883161 8.72684825,19.7301946 L8.71949416,19.7269261 Z",
                fill: "url(#edge-radialGradient-4)",
                opacity: "0.41"
              }), /*#__PURE__*/_jsx("path", {
                d: "M12.5272763,12.1636576 C12.4610895,12.2494553 12.2576265,12.3679377 12.2576265,12.6261479 C12.2576265,12.8394163 12.396537,13.0445136 12.6433074,13.2169261 C13.8183268,14.0340467 16.0335409,13.9261868 16.0392607,13.9261868 C16.9099238,13.9240972 17.7640845,13.6884764 18.5126848,13.2438911 C20.0493361,12.3466459 20.9955373,10.7023764 20.9991829,8.9229572 C21.020428,7.09178988 20.3454864,5.87428016 20.0725681,5.33498054 C18.3410895,1.94801556 14.6035798,0 10.5392218,0 C4.81975095,-0.000565551421 0.160507852,4.59315694 0.080077821,10.3120623 C0.119299611,7.3263035 3.08708171,4.91498054 6.6170428,4.91498054 C6.90303502,4.91498054 8.53400778,4.94276265 10.0489494,5.73782101 C11.3841245,6.43891051 12.0835798,7.28544747 12.5697665,8.12463035 C13.0747471,8.99649805 13.1646304,10.0979767 13.1646304,10.5367704 C13.1646304,10.9755642 12.9407393,11.6259922 12.5272763,12.1636576 Z",
                fill: "url(#edge-radialGradient-5)"
              }), /*#__PURE__*/_jsx("path", {
                d: "M12.5272763,12.1636576 C12.4610895,12.2494553 12.2576265,12.3679377 12.2576265,12.6261479 C12.2576265,12.8394163 12.396537,13.0445136 12.6433074,13.2169261 C13.8183268,14.0340467 16.0335409,13.9261868 16.0392607,13.9261868 C16.9099238,13.9240972 17.7640845,13.6884764 18.5126848,13.2438911 C20.0493361,12.3466459 20.9955373,10.7023764 20.9991829,8.9229572 C21.020428,7.09178988 20.3454864,5.87428016 20.0725681,5.33498054 C18.3410895,1.94801556 14.6035798,0 10.5392218,0 C4.81975095,-0.000565551421 0.160507852,4.59315694 0.080077821,10.3120623 C0.119299611,7.3263035 3.08708171,4.91498054 6.6170428,4.91498054 C6.90303502,4.91498054 8.53400778,4.94276265 10.0489494,5.73782101 C11.3841245,6.43891051 12.0835798,7.28544747 12.5697665,8.12463035 C13.0747471,8.99649805 13.1646304,10.0979767 13.1646304,10.5367704 C13.1646304,10.9755642 12.9407393,11.6259922 12.5272763,12.1636576 Z",
                fill: "url(#edge-radialGradient-6)"
              })]
            })
          })
        })]
      });
    case 'opera':
      return /*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 20 21",
        "aria-hidden": "true",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#FA6758",
          fillRule: "evenodd",
          d: "M9.985 21C4.47 21 0 16.299 0 10.5S4.47 0 9.985 0s9.985 4.701 9.985 10.5S15.5 21 9.985 21zm0-1.78c2.947 0 3.566-3.904 3.566-8.72 0-4.816-.63-8.72-3.566-8.72S6.42 5.684 6.42 10.5c0 4.816.62 8.72 3.566 8.72z"
        })
      });
    case 'unknown':
    default:
      return /*#__PURE__*/_jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [/*#__PURE__*/_jsx("circle", {
          cx: "8",
          cy: "8",
          r: "6.5",
          stroke: "#636C76",
          strokeWidth: 1.25
        }), /*#__PURE__*/_jsx("ellipse", {
          cx: "8",
          cy: "8",
          rx: "3",
          ry: "6.5",
          stroke: "#636C76",
          strokeWidth: 1.25
        }), /*#__PURE__*/_jsx("path", {
          d: "M1.5 8H14.5",
          stroke: "#636C76",
          strokeWidth: 1.25
        })]
      });
  }
}